import { useState } from "react";
import { SportsMapInv } from "./SportMap";
import { Link, useParams } from "react-router-dom";
import { getConf } from "../hooks/useTeam";
import { Spinner } from "flowbite-react";

export const GetAllConf = () => {
  const { data: confData, isLoading, isError } = getConf();
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !confData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch Conference List</p>
      </div>
    );
  }

  let k = Object();
  for (let i = 0; i < confData.length; i++) {
    let start = confData[i][0];
    if (start in k) {
      k[start].push(confData[i]);
    } else {
      k[start] = Array(confData[i]);
    }
  }
  const sorted_conf = Object.fromEntries(Object.entries(k).sort());
  document.title = "NILO - Conferences";
  return (
    <div className="flex justify-center">
      <div className="mx-auto">
        {Object.entries(sorted_conf).map(([k, v]) => {
          return (
            <div key={k} className="flex flex-col w-full my-2 sm:my-10">
              <div className="font-bold">{k}</div>
              <hr className="h-1" />
              <div className="sm:my-4 py-auto sm:columns-3 sm:gap-8">
                {v.map((conf) => {
                  return (
                    <div key={conf} className="py-1 break-inside-avoid-column">
                      <Link to={`/Conf/${conf}`}>{conf}</Link>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const GetConf = () => {
  const conf = useParams().id;
  const { data: confData, isLoading, isError } = getConf(conf);
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !confData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch teams in conference</p>
      </div>
    );
  }

  document.title = "NILO - " + conf + " Teams";
  return (
    <div className="flex sm:justify-around">
      <div className="w-full sm:max-w-7xl sm:flex sm:flex-col">
        {Object.entries(confData).map(([sportName, sport]) => {
          return (
            <div className="my-2 sm:my-10" key={sportName}>
              <div className="font-bold">{SportsMapInv[sportName]}</div>
              <hr className="h-1" />
              <div className="max-w-7xl sm:my-4 py-auto sm:columns-4 sm:gap-16">
                {sport.map((team) => {
                  return (
                    <div
                      key={team.nilo_id}
                      className="py-3 break-inside-avoid-column"
                    >
                      <Link to={`/Team/${team.nilo_id}`}>{team.name}</Link>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
